import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { constantsData, identifiersData, namesData, statusTypesData, urlsData } from "@/data";
import { useApisClient } from "@/hooks";
import { openAlert, setRefetchDriveManagementList } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useTrashDriveManagementFile = () => {
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { logout } = useAuth0();

    const { patch: patchApiClient } = useApisClient();

    const { trashDriveManagementFilePending: trashDriveManagementFilePendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const trashDriveManagementFile = (fileId) => {
        setLoading(true);

        patchApiClient(urlsData.apis.driveManagement.files.url, fileId, { trashed: true })
            .then(() => {
                dispatch(
                    openAlert(t("messages.trashMsgs.success", { entity: t("labels.file") }), statusTypesData.success),
                );
            })
            ["catch"]((err) => {
                displayErrorHandler(
                    err.response.data.message === constantsData.networkError
                        ? t("messages.networkFailure")
                        : err.response.data.message,
                    dispatch,
                    openAlert,
                    err.response.status,
                    logout,
                );
            })
            ["finally"](() => {
                toast.dismiss(`${trashDriveManagementFilePendingToastName}_${toastId}`);

                setLoading(false);

                dispatch(setRefetchDriveManagementList(true));
            });
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(() => t("messages.trashMsgs.pending", { entity: t("labels.file") }), {
                    toastId: `${trashDriveManagementFilePendingToastName}_${toastId}`,
                });
            }
        },
        [loading], //eslint-disable-line
    );

    return {
        loading,
        trashDriveManagementFile,
    };
};

export default useTrashDriveManagementFile;
